import React from 'react';
import { FadeLoader } from 'react-spinners';
import { styledTheme } from 'globalStyles/theme';

const Spinner = ({
  height = 15,
  width = 5,
  radius = 5,
  margin = 2,
}) => (
  <FadeLoader
    className="loading-spinner"
    color={styledTheme.lighterGray}
    loading
    height={height}
    width={width}
    radius={radius}
    margin={margin}
  />
);

export default Spinner;
